<template>
  <div class="resource-main-container" :class="{'resource-main-container-isef' : $isIsef }">
    <span v-if="fromSearch" :class="{'isefCardHeaderTitle' : $isIsef}">
      {{ contentType }}
    </span>
    <span v-else-if="$isYSC">
      {{ `${projectDate()} | ${templateTitle()}` }}
    </span>
    <span v-else-if="fairProject && project.fairName">
      {{ project.fairName }}
    </span>
    <span v-else>
      {{ resourceTitle }}
    </span>
  </div>
</template>

<script>
import cardSelector from '../mixins/cardSelector'
import projectTemplates from '@/mixins/project-templates'

export default {
  props: ['project', 'fromSearch', 'fairProject'],
  mixins: [cardSelector, projectTemplates],
  methods: {
    projectDate: function () {
      return this.project.created ? this.project.created.slice(0, 4) : ''
    },
    templateTitle: function () {
      switch (this.project.sourceProjectID) {
        case this.YSC2024EnglishTemplate:
        case this.YSC2023EnglishTemplate:
        case this.YSC2022EnglishTemplate:
        case this.YSC2021EnglishTemplate:
          return this.YSCEnglishTemplateTitle
        case this.YSC2024FrenchTemplate:
        case this.YSC2023FrenchTemplate:
        case this.YSC2022FrenchTemplate:
        case this.YSC2021FrenchTemplate:
          return this.YSCFrenchTemplateTitle
        case this.YSC2022FinalistTemplate:
          return this.YSC2022FinalistTemplateTitle
        case this.SUD2024CommunityEnTemplate:
        case this.SUD2023CommunityEnTemplate:
        case this.SUD2022CommunityEnTemplate:
        case this.SUD2021CommunityEnTemplate:
          return this.SUDCommunityEnTemplateTitle
        case this.SUD2024CommunityFrTemplate:
        case this.SUD2023CommunityFrTemplate:
        case this.SUD2022CommunityFrTemplate:
        case this.SUD2021CommunityFrTemplate:
          return this.SUDCommunityFrTemplateTitle
        case this.SUD2024RainbowEnTemplate:
        case this.SUD2023RainbowEnTemplate:
        case this.SUD2022RainbowEnTemplate:
        case this.SUD2021RainbowEnTemplate:
          return this.SUDRainbowEnTemplateTitle
        case this.SUD2024RainbowFrTemplate:
        case this.SUD2023RainbowFrTemplate:
        case this.SUD2022RainbowFrTemplate:
        case this.SUD2021RainbowFrTemplate:
          return this.SUDRainbowFrTemplateTitle
        case this.SUD2024CSCNEnTemplate:
        case this.SUD2023CSCNEnTemplate:
        case this.SUD2022CSCNEnTemplate:
        case this.SUD2021CSCNEnTemplate:
          return this.SUDCSCNEnTemplateTitle
        case this.SUD2024CSCNFrTemplate:
        case this.SUD2023CSCNFrTemplate:
        case this.SUD2022CSCNFrTemplate:
        case this.SUD2021CSCNFrTemplate:
          return this.SUDCSCNFrTemplateTitle
        case this.SUD2024CatholicEnTemplate:
        case this.SUD2023CatholicEnTemplate:
        case this.SUD2022CatholicEnTemplate:
        case this.SUD2021CatholicEnTemplate:
          return this.SUDCatholicEnTemplateTitle
        case this.SUD2024CatholicFrTemplate:
        case this.SUD2023CatholicFrTemplate:
        case this.SUD2022CatholicFrTemplate:
        case this.SUD2021CatholicFrTemplate:
          return this.SUDCatholicFrTemplateTitle
        default:
          return this.resourceTitle
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .resource-main-container {
    color: #3e3d3d;
    font-family: $primary-font;
    font-weight: 400;
    font-size: 0.75rem;
    letter-spacing: 2.5px;
    margin: 0rem 0.75rem;
    display: flex;
    min-height: 35px;
    height: 35px;
    text-transform: uppercase;
    &-isef {
      height: 25px;
      min-height: 25px;
      margin-top: 0.35rem;
      margin-bottom : 0rem;
    }
    @include mobile {
      font-size: 0.6rem;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .isefCardHeaderTitle {
    font-family: 'cera-pro';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 1px;
    color: #CECECE;
    margin-left: 5px;
    padding: 14px 0;
  }

</style>
